import React from "react";
import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk";
import sourceflowEnums from "@/sourceflow.enums";
import SimpleFormWithColumn from "components/SimpleFormWithColumn";
import SubBanner from "@/components/SubBanner";
import FooterWave from "@/public/site-assets/svg/footer-wave-2.svg";
import ImageWithText from "components/ImageWithText";
import TextWithStash from "components/TextWithStash";
import TextWithOffices from "components/TextWithOffices";
import SimpleTextWithValues from "components/SimpleTextWithValues";
import TypeOfPlacement from "components/TypeOfPlacement";
import ImageWithTextSlanted from "components/FocusConsultant";
import ImageWithTextQuote from "components/ImageWithTextQuote";
import SF_LatestTestimonials_001 from "components/SF_LatestTestimonials_001";

import { router } from "@/routes";
import { useLocale } from "@/hooks/useLocale";
/**
 *
 * @param global
 * @param meta
 * @returns {JSX.Element}
 * @constructor
 */
export default function PermanentSolutions({
  global,
  who_we_recruit,
  locations,
  tradewind_core_values,
  our_approach,
  our_school,
  permanent_solutions,
  testimonials,
}) {
  const locale = useLocale();

  return (
    <>
      <div className="primary-bg">
        <SubBanner
          global={global}
          pathPrefix={`permanent-solution.about_tradewind.page.sub_banner`}
          heading={`Permanent Solutions`}
          content={<p>Permanent Solutions</p>}
          breadcrumb_title={
            <>
              <span className="active">Permanent Recruitment</span>
            </>
          }
          wave_color={`light-grey`}
          waveIcon={false}
        />
        <ImageWithTextSlanted
          global={global}
          pathPrefix={`permanent-solution.about_tradewind.page.image_with_text_slanted`}
          heading={`The best people, in the best places `}
          content={
            <>
              <p>
                We specialise in attracting the very best senior leadership,
                teaching, and non-teaching support talent within all phases of
                the education sector for permanent positions.{" "}
              </p>{" "}
              <p>
                At Tradewind Permanent Solutions, we understand that identifying
                and hiring the best candidates for permanent teaching and
                support staff vacancies is crucial to the morale and success of
                any educational organisation.
              </p>
              <p>
                We have an established and extensive national network of
                permanent only candidates. We are a trusted education partner to
                a wide range of educational establishments and understand that
                educational organisations thrive when the{" "}
                <strong>best people are in the best places. </strong>
              </p>
            </>
          }
          button_cta_title={``}
          button_cta_link={``}
          imageURL={`/images/placeholders/about-tradewind-difference-placeholder.png`}
          className="style-1"
          heading_tag={`h2`}
        />

        <ImageWithTextQuote
          global={global}
          pathPrefix={`perm.page.image_with_text_quote`}
          heading={`Meet the Head of Permanent Recruitment`}
          content={
            <>
              {/* <p>
                Thank you to all our hardworking teachers and support staff!
              </p>

              <p>
                Tradewind wouldn’t be where we are today without wonderful
                people like you. When we opened our very first London office in
                2001, we had no idea that we’d grow to have more than 12 offices
                nationwide and have helped more than 150,000 educators to find
                their ideal schools.
              </p>

              <p>
                We’re so proud of everything we’ve achieved with your support
                and we’re thrilled to be able to offer a service that you’re
                happy to recommend. We’re here to listen to your needs, provide
                you with unlimited access to free CPD courses and find you the
                education job you’ve always dreamed of.
              </p>

              <p>We listen, we learn and we deliver.</p>

              <p>Why? Because our people matter most.</p>

              <h5>Nick Murphy, CEO</h5> */}
              <p>
                Chris Gartner brings over 20 years of experience as a Senior Director for a leading multinational recruitment agency, 
                where he specialised in education recruitment across the North and Midlands.Drawing on his extensive experience, 
                Chris supports schools, academies, and Trusts nationwide in overcoming the challenges of securing high-quality candidates for permanent roles.
              </p>

              <p>
                “I am passionate about improving the life chances of children and young people, and am committed to helping schools, 
                Trusts, and Dioceses attract and retain exceptional permanent staff.”
              </p>

              <p>
                <strong>
                  Chris Gartner, Head of Permanent Recruitment
                </strong>
              </p>

            </>
          }
          imageURL={'/images/chris.png'}
          heading_tag={`div`}
          className="about-tradewind"
        />

        <ImageWithText
          global={global}
          pathPrefix={`permanent-solution.about_tradewind.page.image_with_text`}
          heading={``}
          content={
            <>
              <h3>Our Approach</h3>
              <br />
              <p>
                Often exceptional permanent candidates are rarely actively
                looking for a new role, what we call “passive candidates”, but
                they can be uncovered and brought directly to you through
                Tradewind Permanent Solution’s bespoke, proactive and targeted
                candidate attraction search approach.
              </p>
              <p>
                This tailored and personalised approach for each permanent role
                we support, led by a team of dedicated and experienced
                consultants, means we can generate additional high quality
                permanent candidates to your crucial permanent roles. We then
                proactively guide and manage candidates through to application,
                increasing your likelihood of appointing the{" "}
                <strong>best person</strong> for the role{" "}
                <strong>at the first time</strong>.
              </p>
              <br />
            </>
          }
          content_html={false}
          post={our_approach}
          className="py-5 purple-label"
        />
      </div>

      <div className="overflow-hidden">
        <div className="bg-light-grey wave-yellow footer">
          <FooterWave />
        </div>
        <TextWithStash
          global={global}
          pathPrefix={`permanent.tradewind.page.text_with_stash`}
          heading={`Popular Education Jobs`}
          content={
            <>
              <p>
                No matter what kind of education job you’re searching for, you
                can rest easy knowing that our expert consultants can help you.
                We recruit for a wide variety of teaching and support jobs,
                including these popular positions:
              </p>
            </>
          }
          content_2={``}
          className=""
          post={who_we_recruit}
          button_cta_link={`/jobs`}
          button_cta_title={`Search all Jobs`}
          heading_tag={`h3`}
        />
        <div className="rotate wave-yellow bg-light-grey footer">
          <FooterWave />
        </div>
      </div>
      <ImageWithText
        global={global}
        pathPrefix={`perm.page.image_with_text`}
        heading={`Our Schools`}
        imageURL={'/images/perm-1.png'}
        content={
          <>
            <p>
              From senior leaders to English teachers, IT specialists, or Finance professionals, 
              we can source and attract high calibre permanent candidates across all phases of education 
              for a wide variety of school based or Multi-Academy 
            </p>
            <br />
          </>
        }
        content_html={true}
        post={our_school}
        className="py-5 purple-label"
      />

      <div className="bg-light-white">
        <TypeOfPlacement
          global={global}
          pathPrefix={`permanent-solution.about_tradewind.page`}
          heading={`Permanent Solutions`}
          content={
            <>
              <p>
                <p>
                  If you’re new to working with an education agency, you may not
                  be familiar with the different types of placements you can
                  choose to work in. Here are the types of placements that we
                  can help you to secure in a schools near you:
                </p>
              </p>
            </>
          }
          post={permanent_solutions}
          className="text-center about-tradewind-page"
        />
        <SimpleTextWithValues
          global={global}
          pathPrefix={`perm.page.simple_text_with_values`}
          heading={`Our Core Values`}
          content={
            <p>
              At Tradewind Permanent Recruitment, our core values run deep throughout every corner or what we 
              stand for and drive us to meet the challenges of recruiting for permanent education roles head-on:
            </p>
          }
          post={tradewind_core_values}
        />
        <div className="footer bg-light-grey wave-white">
          <FooterWave />
        </div>
        <SimpleFormWithColumn
          global={global}
          pathPrefix={`perm.page.simple_form_with_column`}
          heading={`Get in touch`}
          content={
            <p>
              To make a booking or discuss our services further, get in touch with our permanent recruitment team. 
              A consultant will be assigned to assist you with all of your education recruitment needs and they’ll be 
              in touch as soon as possible.
            </p>
          }
          formId={`${sourceflowEnums.forms.permanent_recruitment_submit}`}
          imageURL={``}
          className={`bg-white pb-5 pt-5 pt-lg-0`}
        />
        <div className="bg-white pt-5"></div>
        <div className="footer">
          <FooterWave />
        </div>
      </div>
    </>
  );
}

/**
 *
 * @returns {Promise<{props: {meta: {description: string, canonical: string, title: string}, jobs: *, global}}>}
 */
export async function getStaticProps() {
  const global = (await Global()).toJson();
  const who_we_recruit = (await Collection(`who_we_recruit_-_perm`)).getItems();
  const locations = (await Collection(`locations`)).getItems();
  const tradewind_core_values = (
    await Collection(`tradewind_core_values`)
  ).getItems();
  const our_approach = (await Collection(`our_approach_-_perm`)).getItems();
  const our_school = (await Collection(`our_school_-_perm_copy`)).getItems();
  const permanent_solutions = (
    await Collection(`permanent-solutions`)
  ).getItems();
  const testimonials = (await Collection(`testimonials`))
    .getItems()
    .slice(0, 5);

  const routerKey = "about.about_tradewind";

  return {
    props: {
      global,
      meta: {
        title: "About Tradewind | Tradewind Recruitment",
        description: `${sourceflowEnums.seo.genericDescription}`,
        // canonical: sourceflowEnums.seo.baseURL,
        canonical: `${sourceflowEnums.seo.baseURL}${router[routerKey]["en"]}`,
        // alternate: { link: router[routerKey]["en"], lang: "en" },
      },
      who_we_recruit,
      locations,
      tradewind_core_values,
      our_approach,
      our_school,
      permanent_solutions,
      testimonials,
    },
  };
}

// -- Reference -- //
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflow-head
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflowtext
// https://github.com/sourceflow-uk/components/pkgs/npm/job-search
